var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#apple_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.675-.001s.412 1.923-.807 3.164C11.65 4.405 9.86 4.572 9.86 4.572s-.19-1.886.956-3.08C11.963.3 13.674 0 13.674 0m3.708 6.817s-2.628 1.624-2.078 4.393c.55 2.77 2.677 3.46 2.677 3.46s-1.146 3.082-2.413 4.157c-1.263 1.075-1.648 1.361-2.745 1.052a9 9 0 0 1-.958-.345c-.629-.256-1.193-.485-1.957-.371-.51.076-.982.261-1.431.438-.538.211-1.045.41-1.553.398-.932-.024-2.245-.86-3.534-3.082-1.29-2.22-1.958-5.085-1.648-7.33S3.767 5.462 5.396 5.05c1.502-.38 2.415.011 3.2.348.451.193.86.368 1.313.368 0 0 .429 0 1.289-.36q.113-.046.227-.096c.79-.338 1.644-.705 3.213-.356 1.72.38 2.744 1.862 2.744 1.862"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "apple_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgApple;